<template>
  <div class="c parking-lot-parking-space-detail-overview-statistics">
    <v-layout row wrap>
      <v-flex xs12>
        <!-- <v-select
          :items="items"
          label="Anzeigen für"
          item-text="label"
          item-value="value"
          color="primary"
          v-model="selectedRange"
        ></v-select>  -->
      </v-flex>
      <v-flex xs12 md6>
        <simple-statistic
          :value="parkRotationsPerDay"
          :decimals="1"
          type="number"
          label="Parkrotationen Heute"
        ></simple-statistic>
      </v-flex>
      <v-flex xs12 md6>
        <simple-statistic
          :value="workload"
          suffix="%"
          type="number"
          label="ø-Auslastung Heute"
        ></simple-statistic>
      </v-flex>
      <v-flex xs12 md6>
        <simple-statistic
          :value="parkDuration"
          suffix="h"
          type="time"
          label="ø Parkdauer Heute"
        ></simple-statistic>
      </v-flex>
      <v-flex xs12 md6>
        <simple-statistic
          :value="exceededParkings"
          type="number"
          label="Überschrittene Parkzeiten"
          color="error"
        ></simple-statistic>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import SimpleStatistic from '../../Metrics/SimpleStatistic.vue';

export default {
  name: 'overview-statistics',

  components: {
    SimpleStatistic,
  },

  data() {
    return {
      selectedRange: 'this_month',
      items: [
        { label: 'Dieses Jahr', value: 'this_year' },
        { label: 'Diesen Monat', value: 'this_month' },
        { label: 'Diese Woche', value: 'this_week' },
        { label: 'Heute', value: 'today' },
      ],
      workload: 78,
      parkRotationsPerDay: 2.7,
      parkDuration: '01:05',
      exceededParkings: 21,
    };
  },
};
</script>
